export var TaskExecution;
(function (TaskExecution) {
    TaskExecution[TaskExecution["NoTasksExecuting"] = 0] = "NoTasksExecuting";
    TaskExecution[TaskExecution["ExecutingTasks"] = 1] = "ExecutingTasks";
})(TaskExecution || (TaskExecution = {}));
export var ChannelConfigurations;
(function (ChannelConfigurations) {
    ChannelConfigurations[ChannelConfigurations["Default"] = 0] = "Default";
    ChannelConfigurations[ChannelConfigurations["Monostable"] = 1] = "Monostable";
    ChannelConfigurations[ChannelConfigurations["Bistable"] = 2] = "Bistable";
    ChannelConfigurations[ChannelConfigurations["Gate"] = 3] = "Gate";
    ChannelConfigurations[ChannelConfigurations["Gateway"] = 4] = "Gateway";
})(ChannelConfigurations || (ChannelConfigurations = {}));
export var Roles;
(function (Roles) {
    Roles[Roles["None"] = 0] = "None";
    Roles[Roles["OnOff"] = 1] = "OnOff";
    Roles[Roles["OnOffLights"] = 2] = "OnOffLights";
    Roles[Roles["OnOffWithDelay"] = 3] = "OnOffWithDelay";
    Roles[Roles["GateSwitchState"] = 4] = "GateSwitchState";
    Roles[Roles["GatePulse"] = 5] = "GatePulse";
    Roles[Roles["GateOpenClose"] = 6] = "GateOpenClose";
    Roles[Roles["GatewayOpenClose"] = 7] = "GatewayOpenClose";
    Roles[Roles["GatewayPulse"] = 8] = "GatewayPulse";
    Roles[Roles["Monostable"] = 9] = "Monostable";
    Roles[Roles["Dimmer"] = 10] = "Dimmer";
    Roles[Roles["Blind"] = 11] = "Blind";
    Roles[Roles["Roller"] = 12] = "Roller";
    Roles[Roles["TemperatureSensor"] = 13] = "TemperatureSensor";
    Roles[Roles["BrightnessSensor"] = 14] = "BrightnessSensor";
    Roles[Roles["HumiditySensor"] = 15] = "HumiditySensor";
    Roles[Roles["PowerMeter"] = 16] = "PowerMeter";
    Roles[Roles["RGBLight"] = 17] = "RGBLight";
    Roles[Roles["RGBWLight"] = 18] = "RGBWLight";
    Roles[Roles["LightsWarmth"] = 19] = "LightsWarmth";
    Roles[Roles["TemperatureControl"] = 20] = "TemperatureControl";
    Roles[Roles["BlindsWithPrecisePosition"] = 21] = "BlindsWithPrecisePosition";
    Roles[Roles["MovementSensor"] = 21] = "MovementSensor";
    Roles[Roles["SimpleRemote"] = 22] = "SimpleRemote";
    Roles[Roles["BlindsRemote"] = 23] = "BlindsRemote";
    Roles[Roles["DistanceSensor"] = 24] = "DistanceSensor";
    Roles[Roles["Multisensor"] = 25] = "Multisensor";
    Roles[Roles["IOTransmitter"] = 26] = "IOTransmitter";
    Roles[Roles["DoorOpenClose"] = 27] = "DoorOpenClose";
    Roles[Roles["WindSensor"] = 28] = "WindSensor";
    Roles[Roles["BatterySensor"] = 29] = "BatterySensor";
    Roles[Roles["PressureSensor"] = 30] = "PressureSensor";
})(Roles || (Roles = {}));
//# sourceMappingURL=IDeviceChannel.js.map